import { DOCUMENT, inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FuseSplashScreenService {
    private readonly document = inject(DOCUMENT);
    private readonly router = inject(Router);

    /**
     * Constructor
     */
    constructor() {
        // Hide it on the first NavigationEnd event
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                take(1),
            )
            .subscribe(() => {
                this.hide();
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the splash screen
     */
    public show(): void {
        this.document.body.classList.remove('fuse-splash-screen-hidden');
    }

    /**
     * Hide the splash screen
     */
    public hide(): void {
        this.document.body.classList.add('fuse-splash-screen-hidden');
    }
}
